import React, {useState} from 'react'
import useCountryCode from '@hooks/useCountryCode'
import {PREFIX_EXT_TERMS} from '@i18n/helpers/terms/constants'

import Check from './Check'
import ShowTerms from './ShowTerms'

import styles from './styles.module.css'

export default function SignTerms(props) {
  const {websiteId, termInfos} = props
  const [openModal, setOpenModal] = useState()
  const [termType, setTermType] = useState()
  const countryCode = useCountryCode()

  const termGroups = {}
  const checkboxTermInfos = (termInfos || []).filter(term => !term.omitSignature)
  for (const term of checkboxTermInfos || []) {
    const termGroup = term.termType.replace(PREFIX_EXT_TERMS, '')
    if (termGroup in termGroups) {
      termGroups[termGroup].push(term)
      continue
    }
    termGroups[termGroup] = [term]
  }

  if (!websiteId || !Object.keys(termGroups).length) return null

  const fullLocale = `es-${countryCode.toUpperCase()}`
  const properties = {
    ...props,
    openModal,
    setOpenModal,
    termType,
    setTermType,
    websiteId
  }

  return (
    <div className={styles.container}>
      <ShowTerms {...properties} />
      {Object.keys(termGroups).map(termTypeGroup => (
        <div className={styles.flex} key={termTypeGroup}>
          <Check
            fullLocale={fullLocale}
            termTypeGroup={termTypeGroup}
            termInfoGroup={termGroups[termTypeGroup]}
            {...properties}
          />
        </div>
      ))}
    </div>
  )
}
